// extracted by mini-css-extract-plugin
module.exports = {"container":"FormChangePassword_container__1zoc6","label":"FormChangePassword_label__1m_KX","description":"FormChangePassword_description__n-QZX"};